var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('p',[_vm._v("Churn the subscriptions.")])])}]

export { render, staticRenderFns }